class Carousel extends HTMLElement {
    constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.pagination = this.dataset.pagination === 'true';
        this.spaceBetween = 10;
        this.swiper = null;
    }

    connectedCallback() {
        this.init();
    }

    init() {
        if (this.swiper) return;
        const container = this.querySelector('.swiper-container');
        if (!container) return;
        this.enableSwiper(this.getSwiperConfig());
    }

    getSwiperConfig() {
        const config = {
            spaceBetween: this.spaceBetween,
            slidesPerView: 'auto',
            freeMode: { enabled: true, sticky: true },
            mousewheel: { forceToAxis: true, sensitivity: 0.1 },
            speed: 700,
        };
        if (this.pagination) {
            config.pagination = {
                el: `.${this.sectionId} .swiper-pagination`,
                type: 'progressbar',
            };
        }
        return config;
    }

    enableSwiper(config) {
        this.swiper = new Swiper(this.querySelector('.swiper-container'), config);
    }
}

class CollectionCarousel extends Carousel { }

if (!customElements.get('obd-carousel')) {
    customElements.define('obd-carousel', Carousel);
}
if (!customElements.get('collection-carousel')) {
    customElements.define('collection-carousel', CollectionCarousel);
}
